// extracted by mini-css-extract-plugin
export var blue = "_1v-f";
export var brand = "_1v-b";
export var darkGrey = "_1v-e";
export var disabled = "_1v-4";
export var disabledSubtle = "_1v-5";
export var error = "_1v-6";
export var green = "_1v-g";
export var grey = "_1v-d";
export var icon = "_1v-0";
export var inherit = "_1v-a";
export var lightGrey = "_1v-c";
export var orange = "_1v-i";
export var pink = "_1v-k";
export var primary = "_1v-1";
export var purple = "_1v-l";
export var red = "_1v-j";
export var secondary = "_1v-2";
export var success = "_1v-9";
export var tertiary = "_1v-3";
export var warning = "_1v-7";
export var warningSecondary = "_1v-8";
export var white = "_1v-m";
export var yellow = "_1v-h";